module.exports = __webpack_public_path__ + "static/media/meetingB.808d574d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/meetingB.svg
// module id = 545
// module chunks = 0